import { render } from "./LogViewer.vue?vue&type=template&id=bb060d6c&scoped=true"
import script from "./LogViewer.vue?vue&type=script&lang=js"
export * from "./LogViewer.vue?vue&type=script&lang=js"

import "./LogViewer.vue?vue&type=style&index=0&id=bb060d6c&scoped=true&lang=scss"

import exportComponent from "/tmp/eb47f32b-990a-42a6-a461-0a5e6cce3094/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb060d6c"]])

export default __exports__